import {productAnalyticProps} from '@/constants';
import {HygraphFieldFragments} from '@/types/hygraph.types';
import {Locale} from '@common/hygraph-schema';
import {hygraphLocales} from '@i18n/config';

export const getHygraphLocale = (lang: string): string => {
	if (lang) {
		const adjustedLang = lang?.toLowerCase().replace('-', '_');
		return hygraphLocales[adjustedLang as keyof typeof hygraphLocales] || Locale.En;
	}
	return Locale.En;
};

/**
 * Determines if a given src URL is a hygraph asset
 * @param hygraphMediaDomain
 * @param src
 * @returns boolean
 */
export const isHygraphImageSrc = (hygraphMediaDomain: string, src: string): boolean => {
	const isHygraph = Boolean(src.includes(hygraphMediaDomain) || src.includes('.graphassets.com'));
	return isHygraph;
};

interface HygraphImageIds {
	assetId: string;
	environmentId?: string;
}

/**
 * Attempts to parse hygraph asset URL and return the assetId, environmentId
 */
export const getHygraphImageIds = (hygraphMediaDomain: string, src: string): HygraphImageIds => {
	let assetId = '';
	let environmentId = '';

	if (!src) {
		return {assetId, environmentId};
	}

	const parts = src.split('/');

	if (
		parts.length &&
		parts[2] &&
		isHygraphImageSrc(hygraphMediaDomain, parts[2]) &&
		parts.length > 3
	) {
		assetId = parts[3];

		//new system
		if (parts.length >= 5) {
			environmentId = parts[4];
		}
	}

	return {assetId, environmentId};
};

export const getHygraphExtraProps = (props: HygraphFieldFragments) => {
	switch (props.__typename) {
		case 'CatalogOfferCards':
			if (props.ukey === 'showMoreOffers') {
				return {analytics: productAnalyticProps};
			}

			if (props.ukey === 'pinnedCards') {
				return {
					analytics: {
						...productAnalyticProps,
						eventValue: {
							...productAnalyticProps.eventValue,
							component: 'SpendBalanceSection',
							section: 'Trending'
						}
					}
				};
			}
			break;

		case 'Text': {
			if (props.ukey === 'needSupport') {
				return {
					className: 'nested-link',
					style: {
						paddingTop: '24px',
						textAlign: 'center'
					}
				};
			}
		}
		default:
			return {};
	}
	return {};
};
